import { OFFERS_API_URL } from 'constants/ApiConstants';
import * as types from 'modules/configurator/actionTypes';

/**
 * @param {string} id
 * @param {string} filename
 * @param {Object={}} meta
 * @returns {import('../types').GetPDFRequestAction}
 */
export const getPdfOffer = (id, filename, meta = {}) => ({
  type: types.FETCH_OFFER_PDF_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${OFFERS_API_URL}/${id}/pdf`,
      params: { simplified: false },
    },
    id,
    filename,
  },
  meta,
});

/**
 * @param {string} message
 * @param {Object={}} meta
 * @returns {import('../types').GetPDFFailureAction}
 */
export const getPdfOfferFailure = (message, id, meta = {}) => ({
  type: types.FETCH_OFFER_PDF_FAILURE,
  payload: { id, message },
  error: true,
  meta,
});

/**
 * @param {string} id
 * @param {Object={}} meta
 * @returns {import('../types').GetPDFSuccessAction}
 */
export const getPdfOfferSuccess = (id, meta = {}) => ({
  type: types.FETCH_OFFER_PDF_SUCCESS,
  payload: { id },
  meta,
});
